import * as api from '../api';

export const GetProfileStatus = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/profile/status`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                // api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const ProfileImageUpload = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post(`/profile/image_upload`, data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const ProfileWizardClose = (history) => {
    return new Promise((resolve, reject) => {
        api
            .put(`/profile/status_close`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const ProfileSettingsUpdate = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put(`/profile/profile_settings`, data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const ProfileImageDelete = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove(`/profile/image`, data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetDashboardStats = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/profile/dashboard_stats`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetCustomerChart = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/profile/customer_chart`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetRevenueChart = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/profile/revenue_chart`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetProductCategoryChart = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/profile/product_category_chart`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetOrderAmountChart = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/profile/order_amount_chart`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetMontlyRevenueChart = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/profile/montly_revenue_chart`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetProfilePayments = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/profile/payments`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const DataExport = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/profile/data_export', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};
